import { render, staticRenderFns } from "./TransactionPiggyBank.vue?vue&type=template&id=18aafbc0&"
import script from "./TransactionPiggyBank.vue?vue&type=script&lang=js&"
export * from "./TransactionPiggyBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports